"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateProficiencyFadeCoefficient = exports.calculateProficiencyFade = exports.updateSpacingValue = exports.calculateOptimalSpacingTime = exports.calculateOptimalSpacingTimeInMins = undefined;

var _updateSpacingValue = require("./updateSpacingValue");

Object.defineProperty(exports, "updateSpacingValue", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_updateSpacingValue).default;
  }
});

var _calculateProficiencyFade = require("./calculateProficiencyFade");

Object.defineProperty(exports, "calculateProficiencyFade", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_calculateProficiencyFade).default;
  }
});
Object.defineProperty(exports, "calculateProficiencyFadeCoefficient", {
  enumerable: true,
  get: function get() {
    return _calculateProficiencyFade.calculateProficiencyFadeCoefficient;
  }
});

var _calculateOptimalSpacingTimeInMins = require("./calculateOptimalSpacingTimeInMins");

var _calculateOptimalSpacingTimeInMins2 = _interopRequireDefault(_calculateOptimalSpacingTimeInMins);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.calculateOptimalSpacingTimeInMins = _calculateOptimalSpacingTimeInMins2.default;
exports.calculateOptimalSpacingTime = _calculateOptimalSpacingTimeInMins2.default;